import { render, staticRenderFns } from "./quill-editor-template.vue?vue&type=template&id=ccb8ce18&"
import script from "./quill-editor-template.vue?vue&type=script&lang=js&"
export * from "./quill-editor-template.vue?vue&type=script&lang=js&"
import style0 from "./quill-editor-template.vue?vue&type=style&index=0&id=ccb8ce18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports